/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type MeasurementUnit = "CM" | "IN" | "%future added value";
export type SbSharedRefineMenuDimensionUnitRadioSelect_user = {
    readonly serviceId: string | null;
    readonly profile: {
        readonly measurementUnit: MeasurementUnit | null;
    } | null;
    readonly " $refType": "SbSharedRefineMenuDimensionUnitRadioSelect_user";
};
export type SbSharedRefineMenuDimensionUnitRadioSelect_user$data = SbSharedRefineMenuDimensionUnitRadioSelect_user;
export type SbSharedRefineMenuDimensionUnitRadioSelect_user$key = {
    readonly " $data"?: SbSharedRefineMenuDimensionUnitRadioSelect_user$data;
    readonly " $fragmentRefs": FragmentRefs<"SbSharedRefineMenuDimensionUnitRadioSelect_user">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedRefineMenuDimensionUnitRadioSelect_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Profile",
      "kind": "LinkedField",
      "name": "profile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "measurementUnit",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};
(node as any).hash = 'fc2b7ccc2ef5138d191d7dc53da11515';
export default node;
